// extracted by mini-css-extract-plugin
export default {"teaser":"oad1rvy1","mobile":"mobile","image":"y0pZvSWK","headline":"DKxgeIBU","info":"pPR5jQSI","loader":"zr3UYwtX"};